import React from 'react';

interface PDFContentRendererProps {
  payload: {
    // Prefer backend-provided view_url for any viewing/preview, fall back to file_url for legacy data
    view_url?: string;
    file_url?: string;
    file_path?: string; // backend-internal; do not use to build URLs on FE
    page_from?: number;
    page_to?: number;
    viewer?: {
      allow_download?: boolean;
      start_page?: number;
    };
  };
  file: {
    file_id: string;
    file_name: string;
    file_type: string;
    file_size: number;
    // Prefer backend-provided view_url for any viewing/preview, fall back to file_url for legacy data
    view_url?: string;
    file_url?: string;
    file_path?: string; // backend-internal; do not use to build URLs on FE
    options: any;
  };
}

export const PDFContentRenderer: React.FC<PDFContentRendererProps> = ({ payload, file }) => {
  return (
    <div className="text-center">
      <div className="bg-gray-100 dark:bg-gray-800 rounded-lg p-8 mb-4">
        <div className="text-4xl mb-4">📄</div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
          Tài liệu PDF
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          Trang {payload.page_from || 1} - {payload.page_to || 'cuối'}
        </p>
        <a
          href={
            file.view_url ||
            payload.view_url ||
            file.file_url ||
            payload.file_url ||
            '#'
          }
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Mở PDF
        </a>
      </div>
    </div>
  );
};
